import styles from "./EscalateCaseModal.module.css";
import PropTypes from "prop-types";
import { Modal } from "@wwg/ui";
import { useState, useEffect } from "react";

/**
 *
 * Modal that opens when view is clicked on an escalated incident item. Admins can view the reason for the escalation and any related notes the Case Owner added. (There is a select displayed, but the documentation says it should just display the reason)
 *
 */

export function EscalateCaseModal({ isOpen, onSend, onClose }) {
  const [actionsNeeded, setActionsNeeded] = useState("");
  const [actionsNeeded2, setActionsNeeded2] = useState("");

  return (
    <>
      <Modal
        visible={isOpen}
        onClick={onClose}
        children={
          <div className={styles.container}>
            <div className={styles.header}>Escalate Case</div>
            <div className={styles.hr} />

            <div className={styles.title}>
              Why is this issue being escalated?
            </div>
            <input
              type="text"
              className={styles.input}
              placeholder="Actions needed…"
              onChange={(e) => setActionsNeeded(e.target.value)}
              value={actionsNeeded}
            />

            <div className={styles.title}>What actions need to be taken?</div>
            <textarea
              className={styles.textarea}
              placeholder="Actions needed…"
              onChange={(e) => setActionsNeeded2(e.target.value)}
            >
              {actionsNeeded2}
            </textarea>

            <div className={styles.buttonContainer}>
              <button
                className={styles.button}
                onClick={() => {
                  onSend(actionsNeeded, actionsNeeded2);
                  onClose();
                }}
              >
                Send for Approval
              </button>
            </div>
          </div>
        }
      />
    </>
  );
}

EscalateCaseModal.propTypes = {
  isOpen: PropTypes.bool,
  onView: PropTypes.func,
  onClose: PropTypes.func,
};
